/* SeeMy — boutons de réservation vers la réservation interne.
   - Page avec le bloc « Réservation » (app Réservations SeeMy) : les boutons font défiler jusqu'au module, dans le même onglet.
   - Autres pages : ils ouvrent la page « Prendre rendez-vous », dans le même onglet.
   - Partout : les textes qui parlent de réserver « sur Planity » parlent de notre site.
   Sans JavaScript, les liens Planity restent en place.
   Dans le bloc, le module est passé en vue=bloc : sans logo, titre ni « Tous les services », la page portant déjà le titre,
   et il occupe toute la largeur, sans cadre blanc autour. Le bandeau au-dessus, sans son bouton, est réduit. */
(function () {
  var ANCHOR = 'reservation';
  var PAGE_RDV = '/pages/prendre-rendez-vous';
  var PLANITY = 'a[href*="planity.com"]';
  /* .sm-soinbar__btn : la barre « Réserver ce soin » recopie le lien du bouton du haut, parfois après sa conversion */
  var SEL = PLANITY + ', a.sm-soinbar__btn:not([data-sm-resa])';
  /* Pages soins partageant un service : un service n'est relié qu'à une seule fiche Soin dans Shopify */
  var SERVICE_PAR_PAGE = {
    'browlift': 'regard-sourcils',
    'microshading': 'dermopigmentation',
    'lip-blush': 'dermopigmentation',
    'hydra-exoscalp': 'cuir-chevelu'
  };

  function clean(a) {
    a.removeAttribute('target');
    a.removeAttribute('rel');
    a.querySelectorAll('.visually-hidden').forEach(function (s) {
      if (/nouvelle fen/i.test(s.textContent)) s.remove();
    });
    if (/sur planity/i.test(a.textContent)) a.textContent = 'Réserver un soin';
  }

  function replaceTexts() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!/planity/i.test(n.nodeValue)) return NodeFilter.FILTER_SKIP;
        return n.parentNode.closest('script,style,noscript,textarea') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      t.nodeValue = t.nodeValue
        .replace(/\s+via Planity/gi, '')
        .replace(/sur Planity(\s*\(SeeMy Cosmetics, Paris 8e\))?/gi, 'sur notre site');
    });
  }

  function watchLinks(apply) {
    apply();
    replaceTexts();
    /* Boutons ajoutés après coup par le thème (bouton flottant, barre « Réserver ce soin ») */
    new MutationObserver(apply).observe(document.body, { childList: true });
    window.addEventListener('load', apply);
  }

  function initSansBloc() {
    watchLinks(function () {
      document.querySelectorAll(PLANITY).forEach(function (a) {
        a.setAttribute('href', PAGE_RDV);
        /* Le bouton flottant reste masqué quand un bouton de réservation de la page est à l'écran */
        if (a.closest('main')) a.setAttribute('data-sm-float-protect', '');
        clean(a);
      });
    });
  }

  function init() {
    var module = document.querySelector('.seemy-reservation');
    var frame = module && module.querySelector('iframe');
    if (!frame) return initSansBloc();
    if (!document.getElementById(ANCHOR)) module.id = ANCHOR;
    module.setAttribute('data-sm-float-protect', '');
    module.setAttribute('tabindex', '-1');
    module.style.outline = 'none';

    var page = (location.pathname.match(/\/pages\/([^\/]+)/) || [])[1];
    document.querySelectorAll('.seemy-reservation iframe').forEach(function (f) {
      try {
        var url = new URL(f.getAttribute('src'), location.href);
        if (page && SERVICE_PAR_PAGE[page]) url.searchParams.set('service', SERVICE_PAR_PAGE[page]);
        url.searchParams.set('vue', 'bloc');
        if (url.toString() !== f.src) f.setAttribute('src', url.toString());
      } catch (e) {}
    });

    var st = document.createElement('style');
    st.textContent = 'body.sm-resa-visible .sm-soinbar{display:none!important}' +
      '.seemy-reservation>div{max-width:none!important;padding:0!important}' +
      '.seemy-reservation iframe{border-radius:0!important}' +
      '.ss-band{padding-top:52px!important;padding-bottom:52px!important}' +
      '.ss-band .ss-band__txt{margin-bottom:0!important}';
    document.head.appendChild(st);

    function convert(a) {
      if (a.closest('.ss-band')) { a.remove(); return; }
      a.setAttribute('href', '#' + ANCHOR);
      a.setAttribute('data-sm-resa', '');
      clean(a);
    }
    watchLinks(function () { document.querySelectorAll(SEL).forEach(convert); });

    function goTo() {
      var top = module.getBoundingClientRect().top + window.pageYOffset - 120;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      try { module.focus({ preventScroll: true }); } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-sm-resa]');
      if (!a) return;
      e.preventDefault();
      var drawer = document.getElementById('SmDrawer');
      if (drawer && drawer.classList.contains('is-open')) {
        var close = drawer.querySelector('[data-sm-close]');
        if (close) close.click();
        setTimeout(goTo, 350);
      } else {
        goTo();
      }
      try { history.replaceState(null, '', '#' + ANCHOR); } catch (err) {}
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        document.body.classList.toggle('sm-resa-visible', entries[0].isIntersecting);
      }).observe(module);
    }
    if (location.hash === '#' + ANCHOR) window.addEventListener('load', goTo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
